<template>
  <div :style="cssVars">
    <page-layout
      :noSideBar="false"
      :headerBackgroundColor="cssVars['--outcome-primary']"
    >
      <template v-slot:headerContent>
        <div class="row">
          <span
            :style="`color: ${cssVars['--outcome-secondary']}`"
            class="title"
          >
            {{
              currentUserData.sustainabilityBusiness_name
                ? currentUserData.sustainabilityBusiness_name
                : "Test Business"
            }}
          </span>
        </div>
        <div class="row items-center">
          <span class="headerText text-white">
            {{
              selectedOutcome
                ? "Weld Solutions for"
                : "You need to select an outcome first"
            }}
          </span>
          <sustainability-dropdown
            :model="outcome"
            class="q-ml-sm"
            :style="`width: 230px;
                      background-color: ${
                        selectedOutcome
                          ? cssVars['--outcome-secondary']
                          : 'rgba(0,0, 0, 0.3)'
                      } ;
                      border-radius: 5px;
                      `"
            :options="outcomesList"
            :isObjects="true"
            objectKey="label"
            @input="selectOutcome"
          ></sustainability-dropdown>
        </div>
      </template>
      <template v-slot:content>
        <div class="solutionsSummary column">
          <div class="col-auto">
            <div class="row">
              <div
                class="col-auto q-pa-md"
                style="min-width: 365px; max-width: 365px; background: #f6f6f6"
              >
                <h3
                  class="q-my-none"
                  :style="`color: ${cssVars['--outcome-secondary']}`"
                >
                  Your Goals
                </h3>

                <q-virtual-scroll
                  style="height: calc(100vh - 270px)"
                  class="full-width q-pb-md"
                  :items="formattedGoals"
                >
                  <template v-slot="{ item, index }">
                    <q-card flat :style="`background-color: white`">
                      <q-item
                        v-if="item.basicGoals_id"
                        :key="index"
                        dense
                        clickable
                        v-ripple="{ color: 'primary' }"
                        @click="selectGoal(item, index)"
                        class="q-mb-xs q-pa-md"
                      >
                        <q-item-section>
                          <q-item-label class="goalItem_text">
                            {{ formatPreWrittenGoalText(item).normalText }}
                            <span
                              :style="`color: ${cssVars['--outcome-primary']}`"
                              class="text-bold"
                            >
                              {{ formatPreWrittenGoalText(item).coloredText }}
                            </span>
                          </q-item-label>
                        </q-item-section>
                      </q-item>
                      <q-item
                        v-else
                        dense
                        clickable
                        v-ripple="{ color: 'primary' }"
                        class="q-mb-xs q-pa-md"
                        @click="selectGoal(item, index)"
                      >
                        <q-item-section v-if="item.writeYourOwnGoal">
                          <q-item-label class="goalItem_text">
                            <span
                              :style="`color: ${cssVars['--outcome-primary']}`"
                              class="text-bold"
                            >
                              {{ item.writeYourOwnGoal }}
                            </span>
                          </q-item-label>
                        </q-item-section>
                        <q-item-section v-else>
                          <q-item-label class="goalItem_text">
                            {{
                              item.action == "Reduce" ? "Reduction" : "Increase"
                            }}
                            of
                            <span
                              :style="`color: ${cssVars['--outcome-primary']}`"
                              class="text-bold"
                            >
                              {{ item.sourceData.name }}
                            </span>
                            by
                            <span
                              :style="`color: ${cssVars['--outcome-primary']}`"
                              class="text-bold"
                            >
                              {{
                                (item.sourceData.total *
                                  item.reductionPercentage) /
                                100
                              }}
                              {{ item.sourceData.unit }}
                            </span>
                            ({{ item.action }} {{ item.reductionPercentage }}%
                            by {{ item.due_at.split("-")[0] }})
                          </q-item-label>
                        </q-item-section>
                      </q-item>
                    </q-card>
                  </template>
                </q-virtual-scroll>

                <q-btn
                  class="q-px-sm q-py-xs bg-secondary"
                  label="Back"
                  text-color="white"
                  :style="`z-index: 1; position: absolute; bottom: 12px`"
                  no-caps
                  flat
                  @click="
                    $router.push(`/workspace/${$route.params.outcomesID}`)
                  "
                >
                </q-btn>
              </div>
              <!-- <div > -->
              <q-scroll-area
                class="col q-pa-md"
                :style="`height: calc(100vh - 169px); background: ${cssVars['--outcome-tertiary']}`"
                :thumb-style="{
                  background: '#162c479c',
                  opacity: 1,
                  width: '8px',
                  height: '8px',
                  borderRadius: '20px',
                }"
              >
                <div class="row">
                  <div class="col-12">
                    <h3
                      class="q-my-none"
                      :style="`color: ${cssVars['--outcome-secondary']}`"
                    >
                      Solutions welded to this Goal
                    </h3>
                  </div>
                  <div class="col-12 q-pa-sm">
                    <div
                      class="row"
                      v-if="
                        selectedGoalIndex != null &&
                        formattedGoals[selectedGoalIndex]
                      "
                    >
                      <div class="col-12">
                        <q-card
                          flat
                          :style="`background: ${cssVars['--outcome-secondary']}`"
                          class="text-white q-pa-md"
                        >
                          <div
                            v-if="
                              formattedGoals[selectedGoalIndex].basicGoals_id
                            "
                          >
                            {{
                              formatPreWrittenGoalText(
                                formattedGoals[selectedGoalIndex]
                              ).normalText
                            }}
                            <span class="text-bold">
                              {{
                                formatPreWrittenGoalText(
                                  formattedGoals[selectedGoalIndex]
                                ).coloredText
                              }}
                            </span>
                          </div>
                          <div
                            v-else-if="
                              formattedGoals[selectedGoalIndex].writeYourOwnGoal
                            "
                          >
                            {{
                              formattedGoals[selectedGoalIndex].writeYourOwnGoal
                            }}
                          </div>
                          <div v-else>
                            {{
                              formattedGoals[selectedGoalIndex].action ==
                              "Reduce"
                                ? "Reduction"
                                : "Increase"
                            }}
                            of
                            <span class="text-bold">
                              {{
                                formattedGoals[selectedGoalIndex].sourceData
                                  .name
                              }}
                            </span>
                            by
                            <span class="text-bold">
                              {{
                                (formattedGoals[selectedGoalIndex].sourceData
                                  .total *
                                  formattedGoals[selectedGoalIndex]
                                    .reductionPercentage) /
                                100
                              }}
                              {{
                                formattedGoals[selectedGoalIndex].sourceData
                                  .unit
                              }}
                            </span>
                            ({{ formattedGoals[selectedGoalIndex].action }}
                            {{
                              formattedGoals[selectedGoalIndex]
                                .reductionPercentage
                            }}% by
                            {{
                              formattedGoals[selectedGoalIndex].due_at.split(
                                "-"
                              )[0]
                            }})
                          </div>
                        </q-card>
                      </div>
                      <div v-if="!goalSolutionsLoading" class="col-12 q-pa-md">
                        <div
                          v-if="goalSolutions.length > 0"
                          class="row q-col-gutter-xs"
                        >
                          <div
                            v-for="(solution, index) in goalSolutions"
                            :key="`solutionGoal_${index}`"
                            class="col-12"
                          >
                            <q-card
                              class="bg-white q-pa-md"
                              style="font-weight: 300"
                              flat
                            >
                              <div class="row">
                                <div class="col">
                                  <q-icon
                                    name="mdi-check-circle"
                                    size="sm"
                                    color="primary"
                                    class="q-mr-sm"
                                    @click="unweldSolution(solution)"
                                  ></q-icon>
                                  {{ solution.title }}
                                </div>
                                <div class="col-auto">
                                  <q-icon
                                    name="mdi-close-circle"
                                    size="xs"
                                    color="grey"
                                    class="q-mr-sm cursor-pointer"
                                    @click="unweldSolution(solution)"
                                  ></q-icon>
                                </div>
                              </div>
                            </q-card>
                          </div>
                        </div>
                        <div class="row" v-else>
                          <div class="col-12">
                            <h5>
                              To weld a solution against this goal, you can
                              either
                            </h5>
                            <h5>1. Choose one from our suggested list</h5>
                            <h5>2. Find one you've saved already</h5>
                            <h5>
                              3. Search All Solutions in our solution database
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div v-else class="col-12 q-pa-md">
                        <q-skeleton type="rect" />
                      </div>
                    </div>
                  </div>
                </div>
              </q-scroll-area>

              <!-- </div> -->
            </div>
          </div>
        </div>
      </template>
      <template v-slot:sideBarContent>
        <!-- Wrapping only one DOM element, defined by QBtn -->
        <div class="row full-height full-width sidebar">
          <div class="col-12 q-my-none q-py-lg q-px-md">
            <h3>Welding Solutions</h3>
          </div>
          <!-- <div class="q-pt-sm q-px-md">
            <p>Does this sound like you?</p>

            <q-btn
              v-for="n in 5"
              :key="`selector_${n}`"
              round
              size="xs"
              color="accent"
              :outline="noteSelector != n"
              @click="noteSelected(n)"
              class="q-mx-xs"
            >
              <span class="scaleNoteLevelSelector">{{ n }}</span>
            </q-btn>
          </div> -->
          <div class="col-12 q-px-md" v-if="selectedGoalIndex != null">
            <div class="row">
              <div class="col-12">
                <q-tabs
                  v-model="tab"
                  :style="`color: ${cssVars['--outcome-secondary']}`"
                  inline-label
                  dense
                >
                  <q-tab
                    name="suggested"
                    icon="fas fa-lightbulb"
                    label="Suggested"
                  />
                  <q-tab name="saved" icon="star" label="Saved" />
                </q-tabs>
              </div>
              <div class="col-12">
                <q-virtual-scroll
                  style="height: calc(100vh - 270px)"
                  class="full-width q-pb-md"
                  :items="
                    tab == 'suggested'
                      ? formattedSolutionsList
                      : formattedSavedSolutionsList
                  "
                >
                  <template v-slot="{ item, index }">
                    <q-card flat :style="`background-color: white`">
                      <q-item
                        :key="index"
                        dense
                        clickable
                        v-ripple="{ color: 'primary' }"
                        class="q-mb-xs q-pa-md"
                      >
                        <q-item-section side>
                          <q-checkbox
                            v-model="item.selected"
                            @input="adoptSolutionToGoal(item, index, tab)"
                            color="accent"
                          >
                          </q-checkbox>
                        </q-item-section>
                        <q-item-section>
                          <q-item-label class="goalItem_text">
                            {{ item.title }}
                          </q-item-label>
                        </q-item-section>
                      </q-item>
                    </q-card>
                  </template>
                </q-virtual-scroll>
              </div>
            </div>
          </div>
          <div class="col-12 q-px-md" v-else>
            <div class="row">
              <div class="col-12"></div>
              <div class="col-12">
                <q-scroll-area
                  style="height: calc(100vh - 220px)"
                  :thumb-style="{
                    background: '#162c479c',
                    opacity: 1,
                    width: '8px',
                    height: '8px',
                    borderRadius: '20px',
                  }"
                >
                  Welcome to <span class="highlight">Welding Solutions</span>,
                  here is where you'll be able to select a goal and weld
                  solutions to them. First select a goal youve created and then
                  either choose from our suggested solutions or a solution
                  you've saved from searching our database.
                  <br />
                  <br />
                  <br />
                  <span class="subtext"
                    >Click on a goal to to start welding solutions.</span
                  >
                </q-scroll-area>
              </div>
            </div>
          </div>

          <div class="col-12 q-pa-sm">
            <div class="row q-col-gutter-x-sm">
              <div class="col text-right">
                <q-btn
                  class="bg-accent q-mr-sm q-px-sm q-py-xs"
                  label="Search All Solutions"
                  flat
                  text-color="white"
                  no-caps
                  @click="$router.push(`solutionWelder/solutionsDatabase`)"
                >
                </q-btn>
                <q-btn
                  class="q-px-sm q-py-xs"
                  text-color="white"
                  label="Next"
                  flat
                  :style="`background: ${cssVars['--outcome-secondary']}`"
                  no-caps
                  @click="
                    $router.push(
                      `${$route.path.split('solutionWelder')[0]}solutionSummary`
                    )
                  "
                >
                </q-btn>
              </div>
            </div>
          </div>
        </div>
      </template>
    </page-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageLayout from "@/components/pageLayout/pageLayout.vue";
import SustainabilityDropdown from "@/components/sustainabilityDropdown/sustainabilityDropdown.vue";
import { getCSSVars } from "@/functions/cssVars";

import apiV2 from "@/apiV2";

export default {
  components: {
    PageLayout,
    SustainabilityDropdown,
  },
  computed: {
    ...mapGetters({
      outcomesList: "outcomes/list",
      currentUserData: "auth/currentUserData",
      selectedOutcome: "businessOutcomePlans/selectedOutcome",
      solutionsList: "solutions/sources/list",
      goals: "goals/list",
      goalSolutions: "goals/solutions/list",
      goalSolutionsKeyValue: "goals/solutions/listKeyValue",
      goalSolutionsLoading: "goals/solutions/listLoading",
      savedSolutions: "solutions/business/listSaved",
      savedSolutionsLoading: "solutions/business/listSavedLoading",
    }),
    cssVars() {
      let outcome = this.selectedOutcome;
      return getCSSVars(outcome);
    },
  },
  data: () => ({
    outcome: null,
    selectedYear: null,

    selectedQuestion: null,

    formattedGoals: [],
    selectedGoalIndex: null,

    formattedSolutionsList: [],
    formattedSavedSolutionsList: [],

    tab: "suggested",
  }),
  watch: {
    selectedOutcome: function () {
      this.initSelectedOutcome();
    },
    $route: {
      handler() {
        this.handleRoute();
      },
      props: true,
    },
    goalSolutions: function () {
      this.formatSavedSolutions();
    },
  },
  async mounted() {
    if (this.selectedOutcome) {
      this.initSelectedOutcome();
    }
    this.selectedYear = this.$moment().format("YYYY");

    this.handleRoute();

    this.$store.dispatch("solutions/business/loadAllSaved").then((e) => {
      this.formatSavedSolutions();
    });
    // this.loadData();
  },
  methods: {
    getCSSVars: getCSSVars,
    initSelectedOutcome() {
      this.outcome = this.selectedOutcome;
    },

    handleRoute() {
      if (this.$route.params.hasOwnProperty("goalID")) {
        this.goalBuilderDialog = true;
      } else if (this.$route.params.hasOwnProperty("outcomesID")) {
        this.initGoals();
      }
    },

    initGoals() {
      this.formattedGoals = [];
      this.$store
        .dispatch(
          "goals/loadAllGoalsAndBasicGoalsByOutcomeID",
          this.$route.params.outcomesID
        )
        .then(() => {
          this.formattedGoals = [];
          this.goals.forEach((e) => {
            this.formattedGoals.push({ ...e, selected: false });
          });
          this.filterGoals();
        });
    },

    selectGoal(goal, index) {
      if (this.selectedGoalIndex == index) {
        this.formattedGoals[index].selected = false;
        this.formattedSolutionsList = [];
        this.selectedGoalIndex = null;
      } else {
        let goals = [];
        this.formattedGoals.forEach((e) => {
          if (goal.id == e.id) {
            goals.push({ ...e, selected: true });
          } else {
            goals.push({ ...e, selected: false });
          }
        });
        this.formattedGoals = goals;
        this.selectedGoalIndex = index;
        this.loadSuggestedSolutionsListForGoal(goal);
        this.$store.dispatch("goals/solutions/loadAll", goal.id);
      }
    },

    loadSuggestedSolutionsListForGoal(goal) {
      this.formattedSolutionsList = [];
      apiV2.get("/Solution/GetSuggestedSolutionsForGoal", { params: {goalId: goal.id}})
        .then(response =>{ response.data.suggestedSolutions.forEach((solution) => {
          this.formattedSolutionsList.push({
            ...solution,
            selected: response.data.alreadySelectedIds.includes(solution.id),
          });
          this.formattedSolutionsList = this.formattedSolutionsList.sort(
            (a, b) => {
              return a.title > b.title ? 1 : -1;
            }
          );
        })});
    },

    filterGoals() {
      let goals = this.formattedGoals;
      if (this.sortByDropdown == "Newest") {
        goals.sort((a, b) => (a.created_at < b.created_at ? 1 : -1));
      } else {
        goals.sort((a, b) => (a.created_at > b.created_at ? 1 : -1));
      }
      this.formattedGoals = goals;
      if (this.selectedGoalIndex === null) {
        this.selectGoal(this.formattedGoals[0], 0);
      }
    },
    formatPreWrittenGoalText(goal) {
      if (goal.basicGoalAction) {
        let normalText = goal.basicGoalAction.split(goal.basicGoal);

        if (normalText.length > 0) {
          let coloredText = goal.basicGoalAction.split(normalText[0]);
          return {
            normalText: normalText[0],
            coloredText: coloredText[1],
          };
        }
      } else {
        return {
          normalText: goal.basicGoal,
          coloredText: "",
        };
      }
      let normalText = goal.basicGoalAction.split(goal.basicGoal);

      if (normalText.length > 0) {
        let coloredText = goal.basicGoalAction.split(normalText[0]);
        return {
          normalText: normalText[0],
          coloredText: coloredText[1],
        };
      }
    },

    selectOutcome(outcome) {
      this.$router.push(`/outcomePlans/outcome/${outcome.id}/solutionWelder`);
    },

    formatSavedSolutions() {
      this.formattedSavedSolutionsList = [];
      this.savedSolutions.forEach((e) => {
        this.formattedSavedSolutionsList.push({
          ...e,
          selected: this.goalSolutionsKeyValue[e.id] ? true : false,
        });
        this.formattedSavedSolutionsList =
          this.formattedSavedSolutionsList.sort((a, b) => {
            return a.title > b.title ? 1 : -1;
          });
      });
    },

    async adoptSolutionToGoal(item, index, tab) {
      if (item.selected == false) {
        this.unweldSolution(item);
      } else {
        try {
          let response = await this.$store.dispatch(
            "goals/solutions/adoptAndWeld",
            {
              goals_id: this.formattedGoals[this.selectedGoalIndex].id,
              solution_id: item.id,
            }
          );

          this.$q.notify({
            position: "top-right",
            type: response.Result == "Success" ? "positive" : "negative",
            message: response.Response.Message,
          });

          this.$emit("reloadData");
        } catch (error) {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an error, Please try again later",
          });
        }
      }
    },
    async unweldSolution(solution) {
      try {
        let response = await this.$store.dispatch("goals/solutions/unweld", {
          id: solution.id,
          goals_id: this.formattedGoals[this.selectedGoalIndex].id,
        });

        this.$q.notify({
          position: "top-right",
          type: response.Result == "Success" ? "positive" : "negative",
          message: response.Response.Message,
        });

        this.loadSuggestedSolutionsListForGoal(
          this.formattedGoals[this.selectedGoalIndex]
        );

        this.$emit("reloadData");
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error, Please try again later",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.solutionsSummary {
  h3 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 1.4rem;
    line-height: 1.5rem;
    display: flex;
    align-items: center;
  }

  h5 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 1rem;
    line-height: 1.1rem;
    display: flex;
    align-items: center;
    color: $accent2;
  }
}

.sidebar {
  h3 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 1.3rem;
    line-height: 29px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: var(--outcome-secondary);
    margin: 10px 0px;
  }

  h4 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 800;
    font-size: 1.1rem;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: $accent2;
    margin: 10px 0px;
  }

  .highlight {
    font-weight: 800;
    color: var(--outcome-secondary);
  }

  .subtext {
    font-style: italic;
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: var(--outcome-secondary);
  }
}

.headerText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
}

.twoLinedButton {
  font-size: 0.8rem;
  line-height: 1rem;
  font-weight: 400;
}

.goalItem_text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
}

.goalItem_source_text {
  color: var(--outcome-primary);
}
</style>
